import graphqlClient from "../../../apollo";

class OrdenVentaProvider {
  findOrdenVenta(id) {
    return graphqlClient.query({
      query: require("./gql/ordenVentaFind.graphql"),
      variables: { id },
      fetchPolicy: "network-only",
    });
  }

  paginateOrdenesVenta(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false, filters = {}) {
    return graphqlClient.query({
      query: require("./gql/ordenVentaPaginate.graphql"),
      variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc, filters },
      fetchPolicy: "network-only",
    });
  }

  createOrdenVenta(input) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenVentaCreate.graphql"),
      variables: { input },
    });
  }

  updateOrdenVenta(id, input) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenVentaUpdate.graphql"),
      variables: { id, input },
    });
  }

  cambiarEstado(ordenId, nuevoEstado) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenVentaCambiarEstado.graphql"),
      variables: { ordenId, nuevoEstado },
    });
  }

  crearMovimientoVenta(ordenId) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenVentaCrearMovimientoVenta.graphql"),
      variables: { ordenId },
    });
  }

  registrarPago(ordenId, monto, medioDePago = null) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenVentaRegistrarPago.graphql"),
      variables: { ordenId, monto, medioDePago },
    });
  }

  remitoGenerarPDFBase64(ordenId) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenVentaRemitoGenerarPDFBase64.graphql"),
      variables: { ordenId },
    });
  }
}

export default new OrdenVentaProvider();
